import * as React from 'react';
import { IMoveableSurfaceContextProps, IMoveableSurfaceEventManager } from './moveable-types';

export const MoveableSurfaceContext = React.createContext<IMoveableSurfaceContextProps & IMoveableSurfaceEventManager>({
    containerRef: React.createRef(),
    addUpdateListener: () => { /** Fallback method */ },
    removeUpdateListener: () => false,
    updateMoveables: () => { /** Fallback method */ }
});

export const MoveableSurfaceSizeProvider = MoveableSurfaceContext.Provider;
export const MoveableSurfaceSizeConsumer = MoveableSurfaceContext.Consumer;

export function withMoveableContext<TC,
    TProps extends { context: IMoveableSurfaceContextProps<TC> } =
    { context: IMoveableSurfaceContextProps<TC> }>(Component: React.ComponentType<TProps>) {
    const WithMovable = (props: Omit<TProps, 'context'>) => {
        const context = React.useContext(MoveableSurfaceContext);
        return (
            <Component {...props as TProps} context={context} />
        );
    };
    WithMovable.displayName = `withMoveableContext(${Component.displayName ?? Component.name})`;
    return WithMovable;
}
